import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';
import { AuditProposal } from '../types';

type Body = Partial<{
  note: string;
  workExperience: string;
  education: string;
  training: string;
  workplaceTraining: string;
}>;

export const updateAuditorProposal = async ({
  id,
  data,
}: {
  id: string;
  data: Body;
}): Promise<AuditProposal> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/audit-proposals/${id}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditProposal;
  return response;
};
